import { ReactElement } from 'react';

import { useTheme, Box, Typography } from '@mui/material';

import { TitleProps } from './types';

export default function Title({ title }: TitleProps): ReactElement {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',

        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'divider',

        pb: theme.spacing(2)
      }}>
      <Typography align='center' color='textPrimary' variant='h4'>
        {title}
      </Typography>
    </Box>
  );
}
